import { all, call, put, takeLatest } from "redux-saga/effects";
import invoiceApi from "api/invoice";
import * as act from "store/actions/invoices";

function* getAgencyInvoicesSaga({ query, cb }) {
  try {
    const data = yield call(invoiceApi.getAgencyInvoices, query);
    yield put(act.setAgencyInvoices(data));
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

function* editAgencyInvoiceSaga({ payload, cb }) {
  try {
    yield call(invoiceApi.editAgencyInvoice, payload);
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

function* downloadInvoiceSaga({ invoiceId, cb }) {
  try {
    const url = yield call(invoiceApi.getInvoiceUrl, invoiceId);
    window.open(url, "_blank");
    cb?.(true, url);
  } catch (error) {
    cb?.(false, error);
  }
}

function* resendAgencyInvoiceSaga({ invoiceId, cb }) {
  try {
    yield call(invoiceApi.resendAgencyInvoice, invoiceId);
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

export function* invoicesSaga() {
  yield all([
    takeLatest(act.VM_GET_AGENCY_INVOICES, getAgencyInvoicesSaga),
    takeLatest(act.VM_EDIT_AGENCY_INVOICE, editAgencyInvoiceSaga),
    takeLatest(act.VM_DOWNLOAD_INVOICE, downloadInvoiceSaga),
    takeLatest(act.VM_RESEND_AGENCY_INVOICE, resendAgencyInvoiceSaga),
  ]);
}
